import SetHeaderLinkIndex from "@/components/Header/SetHeaderLinkIndex";
let headerLinks = [
    {url: `https://www.yunkongzutai.cn/index.html`, name: '首页'},
    {url: `/front/pages/redirect/redirect`, name: '组态平台'},
    {url: `https://www.yunkongzutai.cn/product.html`, name: '产品中心'},
]
SetHeaderLinkIndex(headerLinks)
export default headerLinks
